import React, { useState } from "react";
import CommentIcon from "@mui/icons-material/Comment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import moment from "jalali-moment";

// import JS files

// import others files
import pro1 from "../../assets/imgs/media-sample1.png";
import { useNavigate } from "react-router-dom";

const MediaCard = ({ data }) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        className="bg-mygrays-100 rounded-lg p-4 flex flex-col h-[20rem] text-hover-container cursor-pointer"
        onClick={() => navigate(`/news-content/${data.id}`)}
      >
        <div className="basis-2/3 h-0 shrink-0 relative">
          <div className="absolute top-2 right-2">
            <div className="inline-block opacity-75 py-1 md:py-2 px-2 md:px-4	 bg-mygrays-100 rounded-lg  ">
              <span className="text-xs font-bold text-myreds-100">
                {data.news_detail_multi.length > 0 && (
                  <>
                    {data.news_detail_multi[0].type == "video"
                      ? "ویدیو"
                      : data.news_detail_multi[0].type == "image"
                      ? "گزارش تصویری"
                      : "رادیو"}
                  </>
                )}
              </span>
            </div>
          </div>
          <img
            src={data.news_detail[0].cover}
            className="max-h-full	 w-full rounded-xl	"
          />
        </div>
        <div className="basis-1/3 shrink-0 mt-4">
          <span className="text-myblacks-400 font-bold text-hover">
            {data.news_detail[0].header}{" "}
          </span>
          <div className="flex justify-end text-xs text-myblacks-100 mt-4">
            <div className="flex items-center">
              <CommentIcon sx={{ fontSize: "1rem" }} />
              <span className="mr-1">{data.ticket_num} نظر</span>
            </div>
            <div className="flex items-center mr-8">
              <CalendarMonthIcon sx={{ fontSize: "1rem" }} />
              <span className="mr-1">
                {" "}
                {moment(data.news_detail[0].publish_at, "YYYY/MM/DD")
                  .locale("fa")
                  .format("YYYY/MM/DD")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MediaCard;
